var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.791 12.75H3.75C3.336 12.75 3 12.414 3 12C3 11.586 3.336 11.25 3.75 11.25H15.791C16.205 11.25 16.541 11.586 16.541 12C16.541 12.414 16.205 12.75 15.791 12.75Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8635 15.665C12.6715 15.665 12.4785 15.592 12.3325 15.444C12.0395 15.15 12.0415 14.676 12.3345 14.384L14.7285 12L12.3345 9.61498C12.0415 9.32298 12.0395 8.84898 12.3325 8.55498C12.6255 8.26098 13.0995 8.26098 13.3925 8.55298L16.3215 11.469C16.4635 11.609 16.5425 11.801 16.5425 12C16.5425 12.199 16.4635 12.391 16.3215 12.531L13.3925 15.446C13.2465 15.592 13.0545 15.665 12.8635 15.665Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0419 22H12.1569C9.71791 22 7.73291 20.015 7.73291 17.575V16.633C7.73291 16.219 8.06891 15.883 8.48291 15.883C8.89691 15.883 9.23291 16.219 9.23291 16.633V17.575C9.23291 19.187 10.5449 20.5 12.1569 20.5H17.0419C18.6609 20.5 19.9779 19.184 19.9779 17.564V6.425C19.9779 4.813 18.6649 3.5 17.0529 3.5H12.1679C10.5499 3.5 9.23291 4.816 9.23291 6.434V7.367C9.23291 7.781 8.89691 8.117 8.48291 8.117C8.06891 8.117 7.73291 7.781 7.73291 7.367V6.434C7.73291 3.989 9.72291 2 12.1679 2H17.0529C19.4919 2 21.4779 3.985 21.4779 6.425V17.564C21.4779 20.01 19.4869 22 17.0419 22Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/Login.17788083cd10882d00a11017ce74665d.svg";
export { ForwardRef as ReactComponent };